import EUJson from './eu-countries.json';

export * from './duration';
export * from './robust-fetch';
export * from './recentDevices';
export * from './safeStorage';
export * from './user-typing';
export * from './shortcut-handler';
export * from './reactNativeMessage';

//! Make sure this list matches the 2-letter codes in Varnish (production.vcl)
export const EUCountries = Object.keys(EUJson);

export function isEUCountryCode(code: string) {
   return EUCountries.includes(code.toUpperCase());
}
